import styled from 'styled-components';
import theme from '../../assets/styles/theme';

export const TotalizerWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  & div {
    border-right: solid 2px ${theme.colors.neutral.border.regular};
  }
  & div:last-child,
  div:only-child {
    border-right: none;
  }
`;

export const TotalizerContent = styled.div`
  display: block;
  padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-0']};
  width: 100%;
`;
